<template>
  <div class="check-title-div">打卡记录</div>
  <div class="check-insert-div">
    <el-row :gutter="20">
      <el-col :span="1"></el-col>
      <el-col class="check-span" :span="2">
        年
      </el-col>
      <el-col :span="3">
        <el-input v-model="year" placeholder="年"></el-input>
      </el-col>
      <el-col class="check-span" :span="2">
        月
      </el-col>
      <el-col :span="3">
        <el-input v-model="month" placeholder="月"></el-input>
      </el-col>
      <el-col class="check-span" :span="2">
        日
      </el-col>
      <el-col :span="3">
        <el-input v-model="day" placeholder="日"></el-input>
      </el-col>
      <el-col :span="1"></el-col>
    </el-row>
  </div>
  <div class="check-insert-div">
    <el-row :gutter="20">
      <el-col :span="1"></el-col>
      <el-col class="check-span" :span="2">
        距离
      </el-col>
      <el-col :span="3">
        <el-input v-model="distance" placeholder="距离"></el-input>
      </el-col>
      <el-col class="check-span" :span="2">
        心情
      </el-col>
      <el-col :span="3">
        <el-select v-model="mood" placeholder="请选择">
          <el-option
              v-for="item in moodOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col class="check-span" :span="2">
        天气
      </el-col>
      <el-col :span="3">
        <el-select v-model="weather" placeholder="请选择">
          <el-option
              v-for="item in weaOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="1"></el-col>
    </el-row>
  </div>
  <div class="check-insert-div">
    <el-row :gutter="20">
      <el-col :span="1"></el-col>
      <el-col class="check-span" :span="2">
        体力
      </el-col>
      <el-col :span="3">
        <el-input v-model="power" placeholder="体力"></el-input>
      </el-col>
      <el-col class="check-span" :span="2">
        气温
      </el-col>
      <el-col :span="3">
        <el-input v-model="temperature" placeholder="气温"></el-input>
      </el-col>
      <el-col class="check-span" :span="2">
        图片
      </el-col>
      <el-col :span="3">
        <el-input v-model="img" placeholder="图片"></el-input>
      </el-col>
      <el-col :span="1"></el-col>
    </el-row>
  </div>
  <div class="check-insert-div">
    <el-row :gutter="20">
      <el-col :span="1"></el-col>
      <el-col class="check-span" :span="2">
        备注
      </el-col>
      <el-col :span="3">
        <el-input v-model="remark" placeholder="备注"></el-input>
      </el-col>
      <el-col :span="1"></el-col>
    </el-row>
  </div>
  <div class="check-insert-div">
    <el-row :gutter="20">
      <el-col :span="1"></el-col>
      <el-col :span="1">
        <el-button type="primary" @click="saveCheck">保存</el-button>
      </el-col>
      <el-col :span="1"></el-col>
    </el-row>
  </div>

</template>

<script>
import {baseUrl} from "@/utils/request";
import {getNowMonth} from "@/utils/time";
import {postRequest} from "@/utils/service";
import {ElMessage, ElNotification} from "element-plus";

export default {
  name: "insertDayData",
  data() {
    return {
      year: getNowMonth(1),
      month: getNowMonth(2),
      day: getNowMonth(3),
      distance: 0,
      mood: '5',
      remark: '',
      weather: '1',
      temperature: '20~30℃',
      power: 100,
      img: '/img/check/.jpg',
      moodOptions: [{
        value: '1',
        label: '累'
      }, {
        value: '2',
        label: '稍累'
      }, {
        value: '3',
        label: '一般'
      }, {
        value: '4',
        label: '轻松'
      }, {
        value: '5',
        label: '开心'
      }],
      weaOptions: [{
        value: '1',
        label: '晴'
      }, {
        value: '2',
        label: '多云'
      }, {
        value: '3',
        label: '小雨'
      }, {
        value: '4',
        label: '大雨'
      }, {
        value: '5',
        label: '雷雨'
      }, {
        value: '6',
        label: '小雪'
      }, {
        value: '7',
        label: '大雪'
      }, {
        value: '8',
        label: '雾霾'
      }, {
        value: '9',
        label: '阴天'
      }],
    }
  },
  created() {
    this.baseUrl = baseUrl();
  },
  methods: {
    saveCheck() {
      //对象
      let obj = {
        date: this.year + '-' + this.month + '-' + this.day,
        year: this.year,
        month: this.month,
        day: this.day,
        mood: this.mood,
        distance: this.distance,
        remark: this.remark,
        weather: this.weather,
        temperature: this.temperature,
        power: this.power,
        img: this.img
      }

      //保存
      postRequest(this.baseUrl + '/check/insert', obj).then((res) => {
        let num = res.data.data;
        //状态码确认
        if (num > 0) {
          //清空输入框
          this.year = getNowMonth(1);
          this.month = getNowMonth(2);
          this.day = getNowMonth(3);
          this.mood = '5';
          this.distance = 0;
          this.remark = '';
          this.weather = '1';
          this.temperature = '';
          this.img = '/img/check/.jpg';
          this.power = 100;

          ElMessage.success('保存成功..')
        } else {
          ElMessage.error('提交失败..')
        }
      }).catch(function (error) {
        ElMessage.error(error)
      })
    }
  }
}
</script>

<style scoped>
.check-insert-div {
  margin-top: 20px;
}

.check-span {
  height: 32px;
  line-height: 32px;
  font-weight: bold;
  text-align: center;
}

.check-title-div {
  margin-top: 10px;
  margin-left: 10px;
  font-weight: bold;
  height: 32px;
  line-height: 32px;
  font-size: 20px;
}
</style>